import { useMenuState } from '@szhsin/react-menu';
import cn from 'classnames';

import { indianStatesAndUnionTerritories } from 'constants/user';
import i18n from 'i18n/config';
import Box from 'UIKit/Box';
import FilterDropDown from 'UIKit/FilterDropDown';

import { StateDropdownProps } from './ManadatoryDeclarationModal.types';
import styles from './mandatoryDeclarationModal.module.scss';
import SelectedLabel from './SelectedLabel';

const stateOfResidenceLabel = i18n.t('account:stateOfResidence');

const StateDropDown = ({
  selectedValue,
  errorMessage,
  onStateOptionClicked,
}: StateDropdownProps) => {
  const [menuState, toggleMenu] = useMenuState();

  const options = indianStatesAndUnionTerritories.map(state => ({
    label: <SelectedLabel optionId={state} selectedId={selectedValue} />,
    id: state,
    onClick: () => onStateOptionClicked(state),
    checked: selectedValue === state,
    dataTestId: state,
  }));

  return (
    <Box className={styles.dropDownContainer}>
      <Box data-testid="stateOfResidenceLabel" className={styles.dropDownLabel}>
        {stateOfResidenceLabel}
      </Box>

      <FilterDropDown
        menuState={menuState}
        toggleMenu={toggleMenu}
        options={options}
        label={selectedValue || ''}
        testId="state-dropdown"
        closeOnSelect
        className={styles.stateDropdownContainer}
        styleOverrideClasses={{
          button: cn(styles.button, {
            [styles.buttonErrorHighlighted]: errorMessage,
          }),
          labelSection: cn({
            [styles.labelSectionWhenResidence]: selectedValue,
            [styles.labelSectionWhenNoResidence]: !selectedValue,
          }),
          label: styles.label,
          dropDown: styles.dropDown,
          optionLabel: styles.optionLabelClass,
        }}
        autoPosition
      />
    </Box>
  );
};

export default StateDropDown;
